import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@shared/environments';
import {
  Observable,
  retry,
  Subject,
  timer,
} from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private http = inject(HttpClient);

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };
  private apiUrl = `${environment.api}notifications`;
  private stopPolling = new Subject<void>();

  // Start polling for notifications
  startPolling(userId: string): Observable<any> {
    let requestInterval = 5000;
    let retryCount = 5;
    return timer(0, requestInterval).pipe(
      retry({ count: retryCount, delay: requestInterval })
    );
  }

  // Fetch notifications for the given userId
  private fetchNotifications(userId: string): Observable<any[]> {
    const url = `${this.apiUrl}/${userId}`;
    return this.http.get<any[]>(url, this.httpOptions);
  }

  // Stop polling (could be called during logout)
  stopPollingForNotifications(): void {
    this.stopPolling.next();
    this.stopPolling.complete();
  }

  deleteNotification(notificationId: string[]): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}`,
      notificationId,
      this.httpOptions
    );
  }
}
